import React, { useState, useEffect } from 'react';
import { Button, Space, Typography } from 'antd';
import { DownloadOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

const PwaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    window.addEventListener('appinstalled', () => {
      setDeferredPrompt(null);
    });

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!deferredPrompt || dismissed) return null;

  const handleInstall = async () => {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 20,
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
      padding: '12px 20px',
      zIndex: 1050,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      maxWidth: 420,
    }}>
      <Text style={{ flex: 1 }}>Install CodeForce for quick access</Text>
      <Space>
        <Button type="primary" icon={<DownloadOutlined />} onClick={handleInstall} size="small">
          Install
        </Button>
        <Button type="text" icon={<CloseOutlined />} onClick={() => setDismissed(true)} size="small" />
      </Space>
    </div>
  );
};

export default PwaInstallPrompt;
